import type { CongregationMastersPayload } from '../types/congregation';

type RawMastersPayload = {
  centers?: CongregationMastersPayload['centers'] | null;
  spiritualGuides?: CongregationMastersPayload['spiritualGuides'] | null;
  spiritualMasters?: CongregationMastersPayload['spiritualMasters'] | null;
  courses?: CongregationMastersPayload['courses'] | null;
  books?: CongregationMastersPayload['books'] | null;
  skills?: CongregationMastersPayload['skills'] | null;
} | null | undefined;

const toArray = <T>(value: T[] | null | undefined): T[] => {
  return Array.isArray(value) ? value : [];
};

export function normalizeMastersPayload(payload: RawMastersPayload): CongregationMastersPayload {
  return {
    centers: toArray(payload?.centers),
    spiritualGuides: toArray(payload?.spiritualGuides),
    spiritualMasters: toArray(payload?.spiritualMasters),
    courses: toArray(payload?.courses),
    books: toArray(payload?.books),
    skills: toArray(payload?.skills),
  };
}
